import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import listSaga from './list';
import createSaga from './create';
import byIdSaga from './byId';
import updateSaga from './update';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import { PaginatedResponse } from '../types';
import { Seo } from '../../types/seo';

export const moduleName = 'topic';

export type TopicType = 'custom' | 'international' | 'state' | 'industry' | 'service' | 'system';
export type TopicStatus = 'public' | 'private';
export interface Topic {
  id: number,
  title: string,
  topicType: TopicType,
  status: TopicStatus,
  numberOfPosts: number,
  numberOfSubscribers: number,
  isSeoReady: boolean
}

export interface TopicById {
  id: number,
  title: string,
  description: string,
  image: string,
  usaStateId: number,
  subCategoryId: number,
  countryId: number,
  categoryId: number,
  seo: Seo,
  slug: string,
  topicType: TopicType
  isSeoReady: boolean,
  status: TopicStatus,
}

export interface State {
  list: BaseState<PaginatedResponse<Topic>>,
  byId: BaseState<TopicById>,
  update: BaseState< {
    success: boolean,
    message: string,
    messages: string[],
    error: string
  }>,
  create: BaseState<{
    id: number,
    title: string,
    topicType: TopicType
  }>,
}

const models = ['list', 'create', 'byId', 'update'];

export const defaultState: State = createCRUDStates<State>(models);

export const topic = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = topic;

export function useTopic(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
  yield* createSaga();
  yield* byIdSaga();
  yield* updateSaga();
}
